module.exports = __webpack_public_path__ + "img/port_sifit.e9aa6a15.png";